module.exports = __webpack_public_path__ + "static/media/spinner_white.fb7d7af1.svg";